class DashboardRso {
    /**
     * Constructor
     */
    constructor() {
        /**
         * @type {{}}
         */
        this.gameData = {};
        /**
         * @type {NodeListOf<Element>}
         */
        this.donuts = document.querySelectorAll('.donut-container');
        /**
         * @type {NodeListOf<Element>}
         */
        this.answereds = document.querySelectorAll('.block-content .answered');
        /**
         * @type {NodeListOf<Element>}
         */
        this.questions = document.querySelectorAll('.block-content .questions');
        /**
         * @type {NodeListOf<Element>}
         */
        this.gameLink = document.querySelectorAll('.game-link');
        /**
         * _init
         */
        this._init();
    }

    /**
     * Init
     * @private
     */
    _init() {
        const LOADER = new Loader({
            container: '#dashboard-rso',
            color: '#0081c8',
            backgroundOverlay: 'rgba(255,255,255,.55',
            overlay: true,
            center: false
        });

        LOADER.show(true);

        // Get game data
        GameAsync.get().then((response) => {
            this.gameData = JSON.parse(response);
            this._onDataReady();
        }).catch((e) => {
            console.log(e);
        }).finally(() => {
            LOADER.hide();
        });
    }

    /**
     * On data ready
     * @private
     */
    _onDataReady() {
        // Browse game
        for (let i = 0; i < 6; i++) {
            const PERCENT = (this.gameData[i + 1] && this.gameData[i + 1].scorePercent) ? this.gameData[i + 1].scorePercent : 0;
            // Set donut top percent
            new Donut(this.donuts[i], PERCENT);
            // Set donut bottom percent
            new Donut(this.donuts[i + 6], PERCENT);
            // Add answered & questions number
            this.answereds[i].textContent = this.gameData[i + 1].answered;
            this.questions[i].textContent = this.gameData[i + 1].questions;
            // Update link current progress step
            DashboardRso._updateGameLink(this.gameLink[i], this.gameData[i + 1].current);
        }

        // Set donut total percent
        document.getElementsByClassName('full-percent')[0].textContent = this.gameData.all.scorePercent;

        // Display score if in progress
        if (this.gameData.all.scorePercent > 0) {
            document.getElementById('in-progress').style.display = 'block';
        }
    }

    /**
     * update game link
     * @param element
     * @param step
     * @private
     */
    static _updateGameLink(element, step) {
        const URL    = element.href;
        element.href = URL + step;
    }
}
